/**
 * Dialog.Disclosure theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"

const appearances: Components["Dialog"]["Disclosure"]["appearances"] = {
  default: css``
}

export default { appearances }
